import ccEcharts from '@/components/common/echarts/echarts-base.vue';
import echarts from 'echarts';
import 'echarts/map/js/china';
export default {
    name: 'china-map-echarts',
    components: {ccEcharts},
    props: {
        id: {
            type: String,
            default: ''
        },
        data:{
            type:Array,
            default() {
                return [];
            }
        }
    },
    watch: {
        data: {
            deep: true,
            handler: function (val) {
                this.echartsData = val;
                this.initOptions();
            }
        }
    },
    data() {
        return {
            beijing:[{
                name:'北京',
                value:'0'
            }],
            options:{
                tooltip: {
                    show: true,
                    backgroundColor:'transparent',
                    padding:0,
                    formatter: function (params) {
                        const data = params.data;
                        if (params.data && data.title) {
                            let flag;

                            let formatterVal = "<div class='fd-map-tooltip-01'>";
                            if (data.xs !== flag && data.jc !== flag && data.yj !== flag && data.wj !== flag) {
                                formatterVal = "<div class='fd-map-tooltip-01 fd-map-tooltip-szsj'>";
                            }
                            formatterVal += `<p class='fd-map-title'>${data.title}</p>`;
                            const xs = data.xs === flag ? '' : `新收<span>${data.xs}<em>件</em></span>`;
                            const jc = data.jc === flag ? '' : `旧存<span>${data.jc}<em>件</em></span></br>`;
                            const yj = data.yj === flag ? '' : `结案<span>${data.yj}<em>件</em></span>`;
                            const wj = data.wj === flag ? '' : `未结<span>${data.wj}<em>件</em></span>`;
                            const zzjx = data.zzjx === flag ? '' : `正在进行<span>${data.zzjx}<em>件</em></span>`;
                            const jjks = data.jjks === flag ? '' : `即将开始<span>${data.jjks}<em>件</em></span>`;
                            formatterVal += `<p class='fd-map-text'>${zzjx}${jjks}${xs}${jc}${yj}${wj}</p>`;
                            return formatterVal;
                        }
                    }
                },
                geo: [
                    {
                        map: 'china',
                        show: true,
                        roam: false,
                        zoom:1.2,
                        label: {emphasis: {show: false}},
                        itemStyle: {
                            normal: {
                                areaColor: '#c3d0e5',
                                borderColor: '#fff',
                                borderWidth: 0
                            },
                            emphasis: {
                                areaColor: '#0053b4',
                                borderColor: '#fff',
                                borderWidth: 0
                            }
                        },
                        regions: [
                            {
                                name: '南海诸岛',
                                itemStyle: {
                                    // 隐藏地图
                                    normal: {areaColor: '#0053b4'}
                                }
                            }
                        ]
                    }
                ],
                series: [{
                    type: 'map',
                    map: 'china',
                    zoom:1.2,
                    label: {
                        normal: {show: false},
                        emphasis: {show: false}
                    },
                    itemStyle: {
                        normal: {
                            areaColor: 'transparent',
                            borderColor: '#fff',
                            borderWidth: 1
                        },
                        emphasis: {
                            areaColor: '#cce3ff',
                            borderColor: '#fff',
                            borderWidth: 1
                        }
                    },
                    data: []
                }, {
                    type: 'scatter',
                    coordinateSystem: 'geo',
                    label: {normal: {show: false}},
                    symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAYAAAHfZzBgAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQA' +
                        'AAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAKaADAAQAAAABAAAAKQAAAADAIIRfAAAI3ElEQVRYCe1YfWxT1xW/z1/P' +
                        '37ETO8Rx4piEqA0BRkEIBB1FaiNBt9CPVdtUbZMmsbGKdmxZWaAR5TuwZgOVobWJ1G5iGlrpRMVW1FHSJQwCISmEjzQJUZM4sYkT/BEn9vN3' +
                        '/HbOa96bHTtAgD+2iis933vPPfec3z33nnPPNSH3XW5bLGyvyRDnBYiwUV9fLxWLRCSHVot37tzJ0XgGsn///p/V1tZWCYT7a1zMUzr5mZyCtgJto8ITy2' +
                        'sxKetxgCM2/fT1v8diMdL8ak0Tz016dTr2wIED5R0lxj6B+HAbsGrZVamUTVs9rwYHfrtly2vthLCjBQUsMg8ajSz2wUIv8Hwp9bViox0Z8LtO08hoTWZIMfSpD' +
                        'b9cvIwQCr8T27aJaZqeSGZ++G3xdJHHjx8Xl5eXU83Nzez0sZS+x2plzxWq7ClE6AgLOqtUPtFVmO1FBrmdKegs0tu+KC+X8RM4xj179pQogsErk66gPpFIkGKrlYTt40X' +
                        'ekS8Dhw4d0vHMXL1v374FqLZbrWZdRUXscH5+AmgmnklQDcenB4mBQIDYBgcJLZNRNTU1qYcPGbRarfRSjuTqmdraNaf37n3+RsLjRwvgGBbJVxU0JJJEW+UPlu98440o0urq6kxM' +
                        'V9edTcRP/prWLMtSl6zZ/55yGuUDLxMFthflnME9RqHoM+B0dxVM8ZrRQxc1Ns577PLlm0ajkWBASy72W7eIVColebm5ApkJBokjNhZt3f4bXVVVVYgfEIQiAaOj2+0uoyORp1fv3n2' +
                        'QH4TzQ1g4tpFolEThwxLKlUfPbd7+YzgyzaFQaARAJbgB+OHn8X2uRuFFR+reWuaP/yIWjxO7wyGMoz9gadi4sSQSidiShXEDM/0cPnyY7jPnxq+IxewFirAnv7nkDMSe6qYSvRvt6s' +
                        'jLY0+VWTfPND8j0oMHD2aHw+E1sFHjMLHLYDC4nU7nJLTlMpmsAOoFOAb+dw6QfmWPmTQ8ov8fWQBds60wqwnP6kOBDcdD5sYrpEDhgHaqn2bQIETiDGME0X0+1/BPimiI3BEyA' +
                        '48cvmAmXp4mxHiekFxTFCVbe7X7PaSN+XzE0tf2w6KqmsN3uhXTPAZRXchT7lfR9IvKSYk1R6rmbNdvsxEKIpParJ9gqFhn2BPctYqJf5oMANuCTdCXz+bKPDajMfG4Yk51oUhX' +
                        'isIw6vBlrsVCjGKN1irKXvmYwXwa78iWBeZXkm0r2NDr9YovVu1+OfH7fR+qbW4NoSiSo9eTLAhnCZYlprw8grexy+0mGB+x9FdW1H+5Yk3L/NJSYaWCDZuamuLt7e3ewaUrOwy9' +
                        '7Wvp8YgcYh/xwwWMwuMQ1kZGRwnmdVhufu+5P9iXP3UUEpyuDRs2CMsQJCMT2g9yPh1sxuoX3q47YaA1nEnQfhjFC8240YQ0FpmO2559/neg8DosN8wRp34EG2IfBLFbt271QWRu' +
                        '0UtV3JhtaIhjRWR+huHaJcP9S0HBjenCcDBFIBJQKIR+Cu8az9gYZzekY3G5XARTBG04YZmYmMA4mVbSBCIHaFdPwgaMj4+ToFkVhPxkW/d3178fVYjYAUhodESOm5lxrrDLvCq04' +
                        '79KTVU9EV/0/N692ymxeAAurZuOxStU8F0o++zUc3TrlW9DBFfBnBT7oYyUTUECZkh9fX2LoVkMx6Rbp9PZYKl4TkQgRA/146DUDHY+X11d7YB+SklD2AWZFByFfpFI1Au3HLNp0yb' +
                        '+ysTaBVHH5/F4tGCWO/p0ipZHnUcW+FpY4AujUd2RT1egHz/MBWWMHrNVgLHgWGWlgZaSsbgvcfpisWETxM00F5+tXJ5fuGJ4wmxrvAA1ra2GFS3NTr1MJQn4/FTMz6yzDPfetr76q' +
                        'w640vlYM1vRAv8DgUSAc10u/ZOfnOQAotQJv5+Q2CSV8AfWWWzdDuvmLdcfFOh9g0SApeFw1soP/zKqk6qErUWQmCVIJuGKCAW/ZR7sGSz++eudDwI04wFHABXvvnVEI5G+pGClGgk' +
                        'rltGUhJJKJJQIsovkgpkG3DsCCZ98fNaRk5NDsjQaYYxvwKOLjSZibFTExmNUnPHEw12NG3+9eseOHSxe7zwfX6dqBCoCVCgUKmDOUw8MlJWdPHpUPcxkYeojp2miUqmISqkkEnHqJ' +
                        'kQh6ZBBJoMgwbuJOT8/5c2KuRimUQFITLBGa4eyZTHvwkV1Pete+iu8xW6B+gnQL/ybNyNIDB+7du1CBFq5XG6G/jza7y9e8ucjbyrtE9q0VQEjXMoccKlMxr1vxbAATAjDAAYBTy9' +
                        'hozw2tKbij/alq84C2AHgHwTg+B9QFECmOVomnZxMBNvQ0CCB16UGwYKwEnE0al32/qE3VUPjerQaWlQNH4JES90aHuYSzXyTCf/x4doINgAfZBUkmEtHbU9XvjO8cMklkN8P3xAcj' +
                        'bGZwPGLmxEkz4Bg0bIARANAzbqRkSXrT/ztT0opLczFLbwN6WByUavVJNdgSCaRDjV7vvX7P9kCeZQtGAz6YDCj5VImQee/J376yFR/6iDHYRvGwaKJJz75oEEpVXIAcSOHnU7OSt' +
                        'On439oAIQ7m+Bw3PCcALMQcjEH0L0gT0jfp8+d3r/nG8dkMokBsEYfZRehkGA4TDDvxW3EEgMcjEUb8JcaXFGVhDuI6Bz41wkm4Vi0UbFWDccnOztb2AVu4C4/98yMz7Kcjz9e/lTn' +
                        'jWbfmI9iQiE2lK+MMJbiK9fWv/wR6PHD0cA3RQIWo4BaM+/CZytyOz9fKx2eyFJMikgBvGF6JcynjT967TswHszkJEBPK3fdbpwBwkTw1KPL+6690pMl7ri8ceuxSUihAQx65Ci' +
                        '48G2IlV4ECal3gmEYBZxhXf+TFW19q575AOh4OFXf+MexZ1TOoBlCnBZyfdyCNE8GWlq5J0tiAgH5vwaEzwEJGlAaAoC4h35QFsb/l6ZbBRcG4yKIqzS8vdTAr4cPnS8CtRNoY8C' +
                        'TFhPTEALhnkDiRF7plJDETLfD1HhahfPnz59PwWJR56znpwn8XyP8Bxz3C8/lFmJ7AAAAAElFTkSuQmCC',
                    symbolSize: [40, 40],
                    z: 999,
                    zoom:1.2,
                    data: []
                }, {
                    type: 'scatter',
                    coordinateSystem: 'geo',
                    label: {normal: {show: false}},
                    symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAAEhlFeZAAAAAXNSR0IArs4c6QAAA' +
                        'ERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAHaADAAQAAAABAAAAHQAAAADee' +
                        'xZRAAAD8klEQVRIDe1Wb2gcRRR/M/vv9mJpazxqi5j+IZVeTKmiyBlNYoKo1QqtBtovJlik+q3ohwpFcykeEaQNNFAMUUEU1BwIranQlvSukVYwkpZrc7S0SRvRStJLm/RyXvZ2' +
                        'Z6fzLuxdcnsxB36wHzIwO7Pzfr95M2/eezMAJZVgMKg+38p5Dsw5J+3t7WtzA4t3kB8KhVYhkuLnJSX0SGVlZQL7pRfUjFNhFcuSHWau09bWRrZ6tEYh8BnGrCoH9L+2DcGZ7g++mV' +
                        '25s5CsIfBns3Ls7G/XADw0ed0lvGBubwmo3wYVsL53hLn91kPotTK1zNegfZX82ZHeny0ptixxiLQPPp4ETpahXFcz1Sf3a5cKsTlTOQI8/Sjs/xOJ/UGAxscB0hn1YkdHxwoH47Qus' +
                        'hDYL3sOvrhWHvyhVpAjQ1b6Ce3o28K9DIfktDlTOwOipaZpZiTb/HIZHb8pUza6ig8NmKbswhbdM06E+8aJ/H4/b2pqsgkh+fhCwFL5dwsUtWxj0Hgzw9UwUinhw9FWUlloWZczdHV' +
                        '1KQ5p42rhGZxseOVA8q1C/S5iIpF4EEHvvwrwxZ5ZOOOwo6enR5pLdnmFJEkaJdY/h47L3kPHZ6HPKd2H4/HkvG25NM7MzExukXv3EQpZb9ks936m0gzmDHuuxnmzoEC4m2dY3rFtE' +
                        '+31pGHlah3unD1l7H39dFD/cK6BXEvVNE3fxHuHfrWatzJbLl8jxZQG+eDn4fBjuDrmaHURDcNIqqoq13m/C4uworZtm+k0u43O7pCwdS0VBwWBhMPh7P7j8Tim+nkkxCyVJQvkLFDU' +
                        'i3LSgg56V+MnxnqbKe/ZQJ8W5GlO7HMrPLcPH9vnSxbAF/wtSSkm+qGyvRVjqeUx8YR6oNhsIlVdeKHiTKC1pd6YG43FsPMySzEAKtR1vSyWrj1hc+lRxOx6FuDIboCWOoCBYYBbd0' +
                        'WMAXn476lyX+L8kb5AIGBHo9EFbyBXdBdRLAuzrvTwu2PTUJ4Vn4wBVPgA7qQALt/MM5bTsQnGGF73pqgLBnYpSm1KaaZW626/wupGhq3AnolpIJ8ezSsTaTb9lPLjRw/RkX7LAhP' +
                        'v27zU3VvUvJFIhA8ODponUu++Y9q6t17p7LSJkpria/wyzSS3SD91+tVT3QPmzjf+YNUjT/pGY83NzZZbVX5kUaVVVVXS+Pi4l1F9coyt3zVqP7NO3HA3ysn1fi9M/H6Lb/RctWq3' +
                        'EfEyqVZ/+Vqx/krV1NSw/3qmIG4qa53Vd2ODGtkt+kScGxc16/kiu4PoS6IyTdamJEle8CydvZYUMk72F5kfLYN+gDV7GwjPZmlxj4h/S5wlu2/fTvcASGqOlU6LnlMAAAAASUVO' +
                        'RK5CYII=',
                    symbolSize: [30, 30],
                    z: 999,
                    zoom:1.2,
                    data: []
                }]
            },
            echartsData:this.data
        };
    },
    mounted() {
        this.initOptions();
    },
    methods: {
        // 处理options
        initOptions() {
            this.options.series[0].data = this.convertData();
            this.options.series[1].data = this.convertData(this.beijing);
            this.options.series[2].data = this.convertData(this.echartsData);
        },
        convertData(data) {
            const _this = this;
            const geoCoordMap = {};

            /* 获取地图数据*/
            const mapFeatures = echarts.getMap('china').geoJson.features;
            //  console.log(mapFeatures)
            mapFeatures.forEach(function (v) {
                // 地区名称
                const name = v.properties.name;
                // 地区经纬度
                geoCoordMap[name] = v.properties.cp;
            });
            geoCoordMap['广西'] = [108.320004, 22.26402];
            geoCoordMap['海南'] = [109.83119, 20.031971];
            geoCoordMap['浙江'] = [121.053576, 29.987459];
            geoCoordMap['山东'] = [120.000923, 36.875807];
            geoCoordMap['辽宁'] = [122.029096, 39.896767];
            geoCoordMap['江苏'] = [119.767413, 31.841544];
            geoCoordMap['北京'] = [116.805285, 40.5];
            const res = [];
            if (data) {
                for (let i = 0; i < data.length; i++) {
                    const geoCoord = geoCoordMap[data[i].name];
                    if (geoCoord) {
                        res.push({
                            ...data[i],
                            value: geoCoord.concat(data[i].value || 0)
                        });
                    }
                }
            } else {
                for (const key in geoCoordMap) {
                    // 如果是从外面传过来的数据，就是有数据的
                    const _index = _this.echartsData.findIndex(item => item.name === key);
                    if (_index !== -1) {
                        const item = _this.echartsData[_index];
                        const resItem = {
                            ...item,
                            name:key,
                            value:100
                        };
                        res.push(resItem);
                    } else {
                        // 没有数据的
                        res.push({
                            name:key,
                            value:0
                        });
                    }
                }
            }
            return res;
        }
    }
};
